import { render, staticRenderFns } from "./MyIntroduce4.vue?vue&type=template&id=2bc4ba0a&scoped=true"
import script from "./MyIntroduce4.vue?vue&type=script&lang=js"
export * from "./MyIntroduce4.vue?vue&type=script&lang=js"
import style0 from "./MyIntroduce4.vue?vue&type=style&index=0&id=2bc4ba0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc4ba0a",
  null
  
)

export default component.exports